module.exports = __webpack_public_path__ + "static/media/asm4.6b37b1e8.jpg";